import { Button, ButtonIcon, ButtonText } from "@/components/ui/button";
import { Checkbox, CheckboxGroup, CheckboxIcon, CheckboxIndicator, CheckboxLabel } from "@/components/ui/checkbox";
import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import {
    Popover,
    PopoverBackdrop,
    PopoverContent,
} from "@/components/ui/popover";
import {MaterialCommunityIcons} from "@expo/vector-icons";
import {useEffect, useState} from "react";
import {CheckIcon} from "@/components/ui/icon";


export default function CategoryButton({ filterValue, setFilterValue=(values)=>{}, onDelete=()=>{}, openOnMount=false }) {

    const [isOpen, setIsOpen] = useState(false)
    const [values, setValues] = useState([])
    const categories = [
        {key: 0, label: "Machen"},
        {key: 1, label: "Checkliste"},
        {key: 2, label: "Warten"},
        {key: 3, label: "Entscheiden"},
    ]

    useEffect(() => {
        setIsOpen(openOnMount)
    }, [])

    useEffect(() => {
        setValues(filterValue ?? [])
    }, [filterValue, isOpen])

    return (<Popover
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onOpen={() => setIsOpen(true)}
        placement='top left'
        offset={10}
        trigger={({ ...triggerProps }) => (
            <Button
                {...triggerProps}
                size="sm"
                className={`group w-9 h-9 rounded-full items-center justify-center bg-transparent border border-primary-900
                    overflow-hidden ${filterValue ? 'bg-primary-900' : 'bg-transparent'}`}
            >
                <ButtonIcon
                    as={MaterialCommunityIcons}
                    name="format-list-bulleted"
                    size={18}
                    className={`${filterValue ? 'text-white' : 'text-primary-900'} group-hover:text-white`}
                />
            </Button>
        )}
    >
        <PopoverBackdrop bg='transparent' />
        <PopoverContent className="bg-white p-3.5 w-auto gap-3 rounded-r-md shadow-md">
            <Text className="font-semibold">Schrittkategorien</Text>

            {
                categories.map(category => (
                    <Checkbox key={category.key} size='lg'
                              isChecked={values.includes(category.key)}
                              onChange={selected => !selected ? setValues(c => c.filter(cat => cat !== category.key)) : setValues(c => [...c, category.key])}
                              className="flex-1 flex-row items-center justify-between"

                    >
                        <CheckboxLabel><Text>{category.label}</Text></CheckboxLabel>

                        <CheckboxIndicator borderWidth={2}>
                            <CheckboxIcon as={MaterialCommunityIcons} name='check' color='$white' size={18} />
                        </CheckboxIndicator>
                    </Checkbox>
                ))
            }

            <HStack className="flex-row justify-between gap-2">
                <Button
                    onPress={() => {
                        setFilterValue(values);
                        setIsOpen(false);
                    }}
                    className="flex-1 h-[34px] bg-primary-900 px-7 rounded-md"
                >
                    <ButtonText className="text-white">Auswählen</ButtonText>
                </Button>

                <Button
                    onPress={onDelete}
                    className="h-[34px] bg-error-600 px-3 rounded-md"
                >
                    <ButtonIcon
                        as={MaterialCommunityIcons}
                        name="trash-can"
                        className="text-white"
                        size={18}
                    />
                </Button>
            </HStack>
        </PopoverContent>
    </Popover>)

}
